import store from "@/utils/store/cookie";
import { userinfo } from "@/api/UserCenter";

const LOGIN_KEY = "login_status";

const state = {
  footer: true,
  home: true,
  homeActive: false,
  token: store.get(LOGIN_KEY) || null,
  backgroundColor: "#fff",
  userInfo: store.get("userInfo") || null,
  storeItems: store.get("storeItems") || null,
  goName: store.get("goName") || "",
};

const mutations = {
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  LOGIN(state, token, expires_time) {
    state.token = token;
    store.set(LOGIN_KEY, token, expires_time);
  },
  LOGOUT(state) {
    state.token = undefined;
    store.remove(LOGIN_KEY);
    store.remove("userInfo");
  },
  UPDATE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
    store.set("userInfo", userInfo);
  },
  GET_STORE(state, storeItems) {
    state.storeItems = storeItems;
    store.set("storeItems", storeItems);
  },
  GET_TO(state, goName) {
    state.goName = goName;
    store.set("goName", goName);
  },
};

const actions = {
  USERINFO({ state, commit }, force) {
    if (state.userInfo !== null && !force) {
      return Promise.resolve(state.userInfo);
    }
    return userinfo().then((res) => {
      commit("UPDATE_USERINFO", res.data);
      return res.data;
    });
  },
};

export default {
  state,
  mutations,
  actions,
};
